// OpenAI Service for chat functionality
// Uses Express backend so the API key stays server-side

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:3001/api');

const chatConfig = {
  maxTokens: 220,
  temperature: 0.7,
};

/**
 * Send a message to the chat API.
 * The backend chooses the persona from `role`. Messages are only user and assistant turns.
 */
export const sendMessage = async (messages, { role = 'general' } = {}) => {
  try {
    const chatTurns = (messages || [])
      .filter((message) => message.role === 'user' || message.role === 'assistant')
      .map(({ role: turnRole, content }) => ({ role: turnRole, content }));

    const response = await fetch(`${API_BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        role: role || 'general',
        messages: chatTurns,
        max_tokens: chatConfig.maxTokens,
        temperature: chatConfig.temperature,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const isApiAvailable = () => {
  return true;
};

export const getApiStatusMessage = () => {
  return 'Chat API is ready';
};

const openaiService = {
  sendMessage,
  isApiAvailable,
  getApiStatusMessage,
};

export default openaiService;
